import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { capitalizeWords } from '../utils/stringUtils';
import LocationSelector from '../components/booking/LocationSelector';
import ServiceTypesList from '../components/brands/ServiceTypesList';
import ContactCTA from '../components/shared/ContactCTA';

export default function AreaServiceDetail() {
  const { state, city, area } = useParams();
  const [selectedState, setSelectedState] = useState(state || '');
  const [selectedCity, setSelectedCity] = useState(city || '');
  const [selectedArea, setSelectedArea] = useState(area || '');

  const formattedCity = capitalizeWords(city?.replace(/-/g, ' ') || '');
  const formattedState = capitalizeWords(state?.replace(/-/g, ' ') || '');
  const formattedArea = capitalizeWords(area?.replace(/-/g, ' ') || '');

  const title = `AC, Refrigerator, TV, Microwave, Washing Machine Service Center in ${formattedArea}, ${formattedCity}`;

  return (
    <>
      <Helmet>
        <title>{title} | Parakh Services</title>
        <meta 
          name="description" 
          content={`Professional appliance repair services in ${formattedArea}, ${formattedCity}. Expert technicians and same-day service available.`} 
        />
      </Helmet>

      <div className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              {title}
            </h1>
            <p className="text-xl text-gray-600">
              Professional repair services in {formattedArea}, {formattedCity}, {formattedState}
            </p>
          </div>

          <div className="max-w-3xl mx-auto mb-12">
            <LocationSelector
              state={selectedState}
              city={selectedCity}
              area={selectedArea}
              onStateChange={setSelectedState}
              onCityChange={setSelectedCity}
              onAreaChange={setSelectedArea}
            />
          </div>

          <ServiceTypesList
            location={{
              state: formattedState,
              city: formattedCity,
              area: formattedArea
            }}
          />

          <ContactCTA 
            location={{
              state: state || '',
              city: city || '',
              area: area || ''
            }}
          />
        </div>
      </div>
    </>
  );
}